<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="room_list" dense class="elevation-1 mytable" :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Room</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row dense>
            <v-col sm="3" md="1" cols="4"> 
              <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small class="mt-1 ml-2">
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-row justify="center" dense>
              <v-col sm="6" md="6" cols="12">
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>

            </v-row>

          
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 mr-5 button" v-on="on" small>Add Room</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-icon color="error">*</v-icon>
                          <v-text-field v-model="editedItem.room_number" persistent-hint :hint="
                              editedIndex == -1
                                ? 'For example :: A001, A002'
                                : 'For example ::  A001, A002'
                            " label="Enter Room Number" :rules="[(v) => !!v || 'required']" outlined>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.room_name" persistent-hint :hint="
                              editedIndex == -1
                                ? 'For example :: Classroom, Common room'
                                : 'For example ::  Classroom, Common room'
                            " label="Enter Room Name" outlined>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.default_capacity" persistent-hint :hint="
                              editedIndex == -1
                                ? 'For example :: A001, A002'
                                : 'For example ::  A001, A002'
                            " label="Enter Capacity" outlined>
                          </v-text-field>
                        </v-col>
                      </v-row>
                       <v-row>
                        <v-col sm="12" md="12" cols="12">
                          <v-icon color="error">*</v-icon>
                          <v-autocomplete v-model="editedItem.room_type_id" :items="roomType_list" label="Select Room Type" item-text="name" 
                          item-value="id" outlined></v-autocomplete>
                         </v-col>
                      </v-row>
                      <v-row>
                    <v-col cols="auto" class="pt-0 pb-0 ml-9">
                      <v-checkbox dense v-model="editedItem.is_available_for_examination" color="success" label="Is Available for Exam ?" style="font-weight: bold;">
                    </v-checkbox>
                    </v-col>
                  </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
             <v-avatar size="25" class="delete-avatar ml-2">
              <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>

         <template v-slot:item.is_available_for_examination="{ item }">
                <span v-if="item.is_available_for_examination">
                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
            </template>
            <template v-slot:item.isactive="{ item }">
                  <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)" dense></v-switch>
            </template>
            <template v-slot:item.sr_No="{ item }">
                {{ room_list.indexOf(item) + 1 }}
            </template>


      </v-data-table>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {

  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text:"S.No",
        align:"left",
        sortable:"false",
        value: "sr_No",
      },
      {
        text: "Room Number",
        align: "left",
        sortable: false,
        value: "room_number",
      },
      {
        text: "Room Name",
        align: "left",
        sortable: false,
        value: "room_name",
      },
      {
        text: "Capacity",
        align: "left",
        sortable: false,
        value: "default_capacity"

      },
      {
        text: "Is Available for Exam ?",
        align: "left",
        sortable: false,
        value: "is_available_for_examination",
        width: "50px",
      },
      {
        text: "Room Type",
        align: "left",
        sortable: "false",
        value: "room_type"
      },
      {
        text: "IsActive",
        align: "left",
        sortable:"false",
        value: "isactive"

      },
      { text: "Actions", value: "action", sortable: false },
    ],
    room_list: [],
    roomType_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      room_number: "",
      room_name: "",
      default_capacity: "",
      is_available_for_examination:"",
      isactive:"",
      room_type_id:"",
    },
    defaultItem: {
      id: "",
      room_number: "",
      room_name: "",
      default_capacity: "",
      is_available_for_examination:"",
      isactive:"",
      room_type:"",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Room" : "Edit Room";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.room_number = false;
    },

    downloadFile() {
      this.loader = true;

      const excelData = this.room_list.map((item, index) => ({
        "S.No": index + 1,
        "Room Number": item.room_number,
        "Room Name": item.room_name,
        "Capacity": item.default_capacity,
        "Is Available for Exam ?": item.is_available_for_examination ? "YES" : "NO",
        "Room Type": item.room_type,
        "Status": item.isactive ? "Active" : "Inactive"

      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Room List");
      XLSX.writeFile(workbook, "RoomList.xlsx");

      this.loader = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/TimeTable/room")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.room_list = res.data.room_list;
              this.roomType_list = res.data.roomType_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.room_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/TimeTable/editRoom", this.editedItem)
            .then((res) => {
              if (res.data.status == "YES") {
                Object.assign(
                  this.room_list[this.editedIndex],
                  this.editedItem
                );
                this.onLoad();
                this.showSnackbar("#4caf50", "Room Updated Successfully..."); // show snackbar on success
              } else if (res.data.status == "NA") {
                this.showSnackbar("#b71c1c", "Room Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/TimeTable/saveRoom", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.room_list.push(this.editedItem);
              this.onLoad();
              this.showSnackbar("#4caf50", "Room Added Successfully..."); // show snackbar on success
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Room Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.room_number) {
        return true;
      } else {
        if (!this.editedItem.room_number) {
          this.errorMsg.room_name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
     toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/TimeTable/toggleRoom", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Room Updated!");
            this.onLoad();
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            );
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    deleteItem(item) {
      if(confirm("Are You Sure You Want to Delete")){
      {
      const data = {
        id: item.id,
      };
      this.overlay = true;
      axios
        .post("/TimeTable/deleteRoom", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.onLoad();
            this.showSnackbar("#4caf50", "Room Deleted!");
          } else if (res.data.code == "NA") {
            this.showSnackbar( "#b71c1c",res.data.msg || "Something went wrong, Please try again later!");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
      }
    }
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>